import { Swiper, SwiperSlide } from 'swiper/react';
import EFPicture from 'elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

const IconPrev = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const IconNext = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export default function B1() {
    const { useLang, useState, useRouter, useRef } = useGlobal();
    const { t } = useLang('vanliferoadtrips');
    const { locale } = useRouter();
    const [active, setActive] = useState(0);
    const swiperRef = useRef(null) as any;

    const LOCAL_SITES: string[] = ['za', 'kr'];
    const IS_AU: string[] = ['us', 'ca'];
    const IMG_MAP: any = {
        us: '',
        kr: '_kr',
    };

    let cards: any[] = [
        {
            img: 'https://websiteoss.ecoflow.com/figma-uploads/1786957833453-g0lw3a-compressed-002-1.webp',
            imgMobile: 'https://websiteoss.ecoflow.com/figma-uploads/1786957713776-pk6juw-compressed-002-1.webp',
            title: t('secB_tab1_title'),
            desc: t('secB_tab1_desc'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/figma-uploads/1786957848353-6qyf2u-compressed-002-2.webp',
            imgMobile: 'https://websiteoss.ecoflow.com/figma-uploads/1786957783822-koh19q-compressed-002-2.webp',
            title: t('secB_tab2_title'),
            desc: t('secB_tab2_desc'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/figma-uploads/1786957861856-er10m6-compressed-002-3.webp',
            imgMobile: 'https://websiteoss.ecoflow.com/figma-uploads/1786957797149-i0prdu-compressed-002-3.webp',
            title: t('secB_tab3_title'),
            desc: t('secB_tab3_desc'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/figma-uploads/1786957875773-ffc6eu-compressed-002-4.webp',
            imgMobile: 'https://websiteoss.ecoflow.com/figma-uploads/1786957808165-e1jhoo-compressed-002-4.webp',
            title: t('secB_tab4_title'),
            desc: t('secB_tab4_desc'),
        },
    ];

    if (locale === 'au') {
        cards = [
            {
                img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716532793049/2_1_au.png',
                imgMobile: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716534831522/2_1_768_au.png',
                title: t('secB_tab1_title'),
                desc: t('secB_tab1_desc'),
            },
            {
                img: `/responsive/picture/vanlife-roadtrips/2_1${IMG_MAP[locale] || IMG_MAP.us}.jpg`,
                imgMobile: `/responsive/picture/vanlife-roadtrips/2_1_768${LOCAL_SITES.includes(locale) ? `_${locale}` : ''}.jpg`,
                title: t('secB_tab2_title'),
                desc: t('secB_tab2_desc'),
            },
            {
                img: `/responsive/picture/vanlife-roadtrips/2_3${IMG_MAP[locale] || IMG_MAP.us}.jpg`,
                imgMobile: `/responsive/picture/vanlife-roadtrips/2_3_768${IMG_MAP[locale] || IMG_MAP.us}.jpg`,
                title: t('secB_tab3_title'),
                desc: t('secB_tab3_desc'),
            },
            {
                img: `/responsive/picture/vanlife-roadtrips/2_4${IMG_MAP[locale] || IMG_MAP.us}.jpg`,
                imgMobile: `/responsive/picture/vanlife-roadtrips/2_4_768${LOCAL_SITES.includes(locale) ? `_${locale}` : ''}.jpg`,
                title: t('secB_tab4_title'),
                desc: t('secB_tab4_desc'),
            },
            {
                img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716532728623/2_5_au.png',
                imgMobile: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716533824350/2_5_768_au.png',
                title: t('secB_tab5_title'),
                desc: t('secB_tab5_desc'),
            },
        ];
    } else if (locale === 'uk') {
        cards.splice(1, 1);
    } else if (IS_AU.includes(locale)) {
        cards.push({
            img: 'https://websiteoss.ecoflow.com/upload/image/1754363285055/Frame%201612690202.jpg',
            imgMobile: 'https://websiteoss.ecoflow.com/upload/image/1754363285051/m_img01.jpg',
            title: t('secB_tab5_title'),
            desc: t('secB_tab5_desc'),
        });
    }

    let originX = 0,
        startX = 0;
    const onTouchStart = (e: any) => {
        originX = parseFloat(e.currentTarget?.style.left) || 0;
        startX = e.targetTouches[0]?.clientX;
    };
    const onTouchMove = (e: any) => {
        const moveX = e.targetTouches[0]?.clientX;
        const endX = originX + moveX - startX;
        if (endX <= 0 && endX >= window.innerWidth - e.currentTarget.offsetWidth) {
            e.currentTarget.style.left = `${endX}px`;
        }
    };

    const handlePrev = () => swiperRef.current?.slidePrev();
    const handleNext = () => swiperRef.current?.slideNext();

    return (
        <div id="vanlife-roadtrips-B1" className={`vanlife-roadtrips-B1 ${css['vanlife-roadtrips-B1']}`}>
            <div className="oc-carousel">
                <div className="oc-carousel__header">
                    <p className="oc-carousel__title">{t('secB_title')}</p>
                </div>

                <div className="oc-carousel__viewport">
                    <Swiper
                        className="oc-carousel__swiper"
                        slidesPerView={'auto'}
                        centeredSlides={false}
                        slidesOffsetBefore={24}
                        slidesOffsetAfter={24}
                        spaceBetween={12}
                        initialSlide={0}
                        breakpoints={{
                            768: {
                                centeredSlides: false,
                                slidesOffsetBefore: 48,
                                slidesOffsetAfter: 48,
                            },
                            1025: {
                                centeredSlides: true,
                                slidesOffsetBefore: 0,
                                slidesOffsetAfter: 0,
                            },
                        }}
                        onSwiper={(swiper) => {
                            swiperRef.current = swiper;
                        }}
                        onSlideChange={(swiper) => setActive(swiper.activeIndex)}
                    >
                        {cards.map((item: any, k: number) => (
                            <SwiperSlide className={`oc-carousel__slide oc-carousel__slide--${k + 1}`} key={k}>
                                <div className="oc-carousel__img">
                                    <EFPicture src={item.img} srcMobile={item.imgMobile} alt={item.title} />
                                </div>
                                <div className="oc-carousel__body">
                                    <p className="oc-carousel__slide-title">{item.title}</p>
                                    <p className="oc-carousel__slide-desc">{item.desc}</p>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                    <button className="oc-carousel__nav-btn oc-carousel__nav-btn--prev" onClick={handlePrev} aria-label="Previous slide">
                        <IconPrev />
                    </button>
                    <button className="oc-carousel__nav-btn oc-carousel__nav-btn--next" onClick={handleNext} aria-label="Next slide">
                        <IconNext />
                    </button>
                </div>

                <div className="oc-carousel__tabs">
                    <div className="oc-carousel__tabs-inner">
                        {cards.map((card: any, k: number) => (
                            <button
                                key={k}
                                className={`oc-carousel__tab${active === k ? ' oc-carousel__tab--active' : ''}`}
                                onClick={() => {
                                    swiperRef.current?.slideTo(k);
                                    setActive(k);
                                }}
                            >
                                {card.title}
                            </button>
                        ))}
                    </div>
                </div>

                <div className="oc-carousel__mobile">
                    <div className="oc-carousel__mobile-img">
                        <EFPicture src={cards[active]?.imgMobile} alt={cards[active]?.title} />
                    </div>
                    <div className="oc-carousel__mobile-tabs">
                        <ul className="oc-carousel__mobile-list" onTouchStart={onTouchStart} onTouchMove={onTouchMove}>
                            {cards.map((card: any, k: number) => (
                                <li
                                    className={`oc-carousel__mobile-tab${active === k ? ' oc-carousel__mobile-tab--active' : ''}`}
                                    key={k}
                                    onClick={() => setActive(k)}
                                >
                                    {card.title}
                                </li>
                            ))}
                        </ul>
                    </div>
                    <p className="oc-carousel__mobile-desc">{cards[active]?.desc}</p>
                </div>
            </div>
        </div>
    );
}
